import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							These are my works. Mobile apps and websites.
						</div>

						<div className="subtitle projects-subtitle">
						With a robust background in Android app development across diverse domains such as retail, insurance, and hospitality, I've crafted applications available on the Play Store, impacting thousands of users. Additionally, I've successfully deployed dynamic websites using ReactJS. Beyond client projects, I'm the proud founder of a startup product developed in Flutter, securing a noteworthy 1 million Indian Rupees in investment. My journey embodies a fusion of technical prowess and entrepreneurial spirit, exemplifying a commitment to innovation and delivering impactful solutions that resonate with both users and investors alike.
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
